// @store-module
import { Module } from "vuex";
import { CenterDesAvocatsState, initialState } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const profileStore: Module<any, CenterDesAvocatsState> = {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export default profileStore;
